import { useEffect, useState } from "react";
import {
  isEmbedded,
  getParentScrollTop,
  subscribeParentScroll,
} from "../utils/embeddedScroll.js";

/**
 * Exposes the parent window's scroll offset to React components when the page is
 * embedded in a pym iframe. Returns { isEmbedded, parentScrollTop }.
 *
 * For a standalone (non-embedded) page this returns isEmbedded=false and a static
 * parentScrollTop of 0, so callers can keep their normal scroll logic untouched.
 */
export default function useParentScroll() {
  const embedded = isEmbedded();
  const [parentScrollTop, setParentScrollTop] = useState(getParentScrollTop());

  useEffect(() => {
    if (!embedded) return undefined;
    setParentScrollTop(getParentScrollTop());
    return subscribeParentScroll(setParentScrollTop);
  }, [embedded]);

  return { isEmbedded: embedded, parentScrollTop };
}
